module.exports = __webpack_public_path__ + "img/LV shoe.277af50e.jpg";